<template>
  <div class="template">
    <IstcDesktop class="template__Desktop" />
    <IstcMobile class="template__Mobile" />
  </div>
</template>

<script>
import IstcMobile from '@/components/services/ISTC/IstcMobile.vue'
import IstcDesktop from '@/components/services/ISTC/IstcDesktop.vue'
export default {
  name: 'ISTCView',
  components: {
    IstcDesktop,
    IstcMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>